import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { userService, auth } from '../../../../../services';
import '../../MyMemberships/MembershipsPage/MembershipsPage.scss';
//import CommitteeDetails from '../CommitteeDetails/CommitteeDetails';
import CommitteeMemberList from '../CommitteeMembers/CommitteeMemberList';
//import CommitteeDocuments from '../CommitteeDocuments/CommitteeDocuments';

class CommitteesPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {},
      tabs: [
        //{
        //	id: 'Committee Details',
        //	label: 'Group Details'
        //},
        {
          id: 'Memberships',
          label: 'Memberships'
        },
        // {
        //   id: 'Documents',
        //   label: 'Documents'
        // },
        {
          id: 'goBack',
          label: 'Back to Dashboard'
        }
      ],
      activeTab: 'Memberships',
      loading: true
    };

    if (!auth.isAuthenticated()) {
      this.props.history.push('/');
    }
  }

  getUserProfile() {
    console.log("committeeId in committeesPage", this.props.match.params.committeeId)
    var userName = auth.getAuthUserEmail();
    if (userName) {
      userService.getUserProfile(userName).then(({ data }) => {
        this.setState({ user: data, loading: false });
      });
    }
  }

  profileUpdated = (profile) => {
    this.setState({ user: profile });
  };

  selectTab = (event) => {
    const target = event.target;
    this.setState({ activeTab: target.id });
  };

  tabsContent = () => {
    switch (this.state.activeTab) {
      //case 'Committee Details':
      //	return <CommitteeDetails committeeMemberId={this.props.match.params.committeeMemberId}/>;
      case 'Memberships':
        return <CommitteeMemberList />;
      //case 'Documents':
      //	return <CommitteeDocuments />;

      case 'goBack':
        return this.props.history.push('/dashboard');
      default:
        return null;
    }
  };

  render() {
    return (
      <div className="membership-details">
        <div className="membership-details-container">
          {/* <h1 className="pt-3 pb-3">{this.state.activeTab }</h1> */}
          <div className="cols">
            <div className="col-md-4 col-sm-12 col-left">
              <ul className="list-group account-tabs">
                {this.state.tabs.map((tab, index) => {
                  const cls = '';
                  return (
                    <li className="list-group-item" key={index}>
                      <a className={tab.id == this.state.activeTab ? `${cls} active` : cls}
                        onClick={this.selectTab}
                        id={tab.id}
                        key={index}
                        tabIndex="0"
                      >{tab.label}</a>
                    </li>
                  );
                })}
              </ul>
            </div>
            <div className="col-md-8 col-sm-12 col-right">{this.tabsContent()}</div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(connect(null, null)(CommitteesPage));
